// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-project-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.add-project-modal-content {
  background: white;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
}

.add-project-modal-content h2 {
  margin: 0 0 20px 0;
  color: #333;
  font-size: 24px;
  font-weight: 600;
}

.add-project-modal-field {
  margin-bottom: 16px;
}

.add-project-modal-field label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #555;
  font-size: 14px;
}

.add-project-modal-field input,
.add-project-modal-field textarea {
  width: 100%;
  padding: 12px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  box-sizing: border-box;
}

.add-project-modal-field input:focus,
.add-project-modal-field textarea:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}

.add-project-modal-field input:disabled,
.add-project-modal-field textarea:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.7;
}

.add-project-modal-field textarea {
  resize: vertical;
  min-height: 80px;
}

.add-project-modal-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 24px;
}

.cancel-button,
.create-button {
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 2px solid transparent;
  min-width: 100px;
}

.cancel-button {
  background: #f8f9fa;
  color: #666;
  border-color: #e9ecef;
}

.cancel-button:hover:not(:disabled) {
  background: #e9ecef;
  color: #333;
}

.cancel-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.create-button {
  background: #28a745;
  color: white;
  border-color: #28a745;
}

.create-button:hover:not(:disabled) {
  background: #218838;
  border-color: #218838;
  transform: translateY(-1px);
}

.create-button:disabled {
  background: #6c757d;
  border-color: #6c757d;
  cursor: not-allowed;
  transform: none;
  opacity: 0.7;
}

/* Responsive */
@media (max-width: 576px) {
  .add-project-modal-content {
    width: 95%;
    margin: 20px;
    padding: 20px;
  }
  
  .add-project-modal-actions {
    flex-direction: column;
  }
  
  .cancel-button,
  .create-button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AddProjectModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,wDAAwD;EACxD,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":[".add-project-modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.add-project-modal-content {\n  background: white;\n  padding: 24px;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n  width: 90%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.add-project-modal-content h2 {\n  margin: 0 0 20px 0;\n  color: #333;\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.add-project-modal-field {\n  margin-bottom: 16px;\n}\n\n.add-project-modal-field label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #555;\n  font-size: 14px;\n}\n\n.add-project-modal-field input,\n.add-project-modal-field textarea {\n  width: 100%;\n  padding: 12px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 14px;\n  font-family: inherit;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  box-sizing: border-box;\n}\n\n.add-project-modal-field input:focus,\n.add-project-modal-field textarea:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);\n}\n\n.add-project-modal-field input:disabled,\n.add-project-modal-field textarea:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.add-project-modal-field textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n.add-project-modal-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  margin-top: 24px;\n}\n\n.cancel-button,\n.create-button {\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: 2px solid transparent;\n  min-width: 100px;\n}\n\n.cancel-button {\n  background: #f8f9fa;\n  color: #666;\n  border-color: #e9ecef;\n}\n\n.cancel-button:hover:not(:disabled) {\n  background: #e9ecef;\n  color: #333;\n}\n\n.cancel-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.create-button {\n  background: #28a745;\n  color: white;\n  border-color: #28a745;\n}\n\n.create-button:hover:not(:disabled) {\n  background: #218838;\n  border-color: #218838;\n  transform: translateY(-1px);\n}\n\n.create-button:disabled {\n  background: #6c757d;\n  border-color: #6c757d;\n  cursor: not-allowed;\n  transform: none;\n  opacity: 0.7;\n}\n\n/* Responsive */\n@media (max-width: 576px) {\n  .add-project-modal-content {\n    width: 95%;\n    margin: 20px;\n    padding: 20px;\n  }\n  \n  .add-project-modal-actions {\n    flex-direction: column;\n  }\n  \n  .cancel-button,\n  .create-button {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
